import { supabase } from '../lib/supabase';

export const playerVerificationService = {
  // Get all unverified players (verified_status = false)
  async getUnverifiedPlayers() {
    const { data, error } = await supabase
      ?.from('player_master_profiles')
      ?.select('*')
      ?.eq('verified_status', false)
      ?.not('user_id', 'is', null)
      ?.order('created_at', { ascending: false });
    
    if (error) throw error;
    return { data: data?.map(this.toCamelCase) };
  },

  // Get all verified players (verified_status = true)
  async getVerifiedPlayers() {
    const { data, error } = await supabase
      ?.from('player_master_profiles')
      ?.select('*')
      ?.eq('verified_status', true)
      ?.not('user_id', 'is', null)
      ?.order('created_at', { ascending: false });
    
    if (error) throw error;
    return { data: data?.map(this.toCamelCase) };
  },

  // Verify player and activate their account
  async verifyPlayer(playerId, notes) {
    const { data: { user } } = await supabase?.auth?.getUser();
    
    if (!user) {
      throw new Error('User not authenticated');
    }
    
    const { data, error } = await supabase
      ?.from('player_master_profiles')
      ?.update({
        verified_status: true,
        updated_at: new Date()?.toISOString()
      })
      ?.eq('id', playerId)
      ?.select()
      ?.single();
    
    if (error) throw error;
    return { data: this.toCamelCase(data) };
  },

  // Revoke verification
  async revokeVerification(playerId) {
    const { data, error } = await supabase
      ?.from('player_master_profiles')
      ?.update({
        verified_status: false,
        updated_at: new Date()?.toISOString()
      })
      ?.eq('id', playerId)
      ?.select()
      ?.single();
    
    if (error) throw error;
    return { data: this.toCamelCase(data) };
  },

  toCamelCase(obj) {
    if (!obj) return obj;
    return {
      id: obj?.id,
      userId: obj?.user_id,
      fullName: obj?.full_name,
      dateOfBirth: obj?.date_of_birth,
      placeOfBirth: obj?.place_of_birth,
      nationalityPrimary: obj?.nationality_primary,
      nationalitySecondary: obj?.nationality_secondary,
      height: obj?.height,
      weight: obj?.weight,
      preferredFoot: obj?.preferred_foot,
      primaryPosition: obj?.primary_position,
      secondaryPositions: obj?.secondary_positions,
      currentClub: obj?.current_club,
      currentLeague: obj?.current_league,
      currentCountry: obj?.current_country,
      squadNumber: obj?.squad_number,
      contractType: obj?.contract_type,
      contractStartDate: obj?.contract_start_date,
      contractEndDate: obj?.contract_end_date,
      availableForTransfer: obj?.available_for_transfer,
      availableForLoan: obj?.available_for_loan,
      transferListedDate: obj?.transfer_listed_date,
      currentMarketValue: obj?.current_market_value,
      highestMarketValue: obj?.highest_market_value,
      currency: obj?.currency,
      agentName: obj?.agent_name,
      agencyName: obj?.agency_name,
      agentEmail: obj?.agent_email,
      agentPhone: obj?.agent_phone,
      representationContractUntil: obj?.representation_contract_until,
      profileVisibility: obj?.profile_visibility,
      verifiedStatus: obj?.verified_status,
      fifaVerified: obj?.fifa_verified,
      profilePhoto: obj?.profile_photo,
      actionPhotos: obj?.action_photos,
      dataSource: obj?.data_source,
      lastUpdated: obj?.last_updated,
      createdAt: obj?.created_at,
      updatedAt: obj?.updated_at
    };
  }
};